import { useMutation, UseMutationResult } from "@tanstack/react-query";
import {
  WiseOwlApiResponse,
  WiseOwlChatType,
  WiseOwlGetChatAboutTicketIdResponseData,
  WiseOwlIngress,
  WiseOwlProps,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

import { WiseOwlApi } from "@twiliointernal/org/twilio/e2-commons/shared/api";

interface GetChatMutationProps {
  chatId: string;
  interruptedChatId?: string;
}

const useGetChat = ({
  applicationId,
  ingress,
  ticket,
  token,
}: WiseOwlProps): UseMutationResult<
  WiseOwlApiResponse<WiseOwlChatType | WiseOwlGetChatAboutTicketIdResponseData>,
  any,
  GetChatMutationProps
> => {
  return useMutation({
    mutationFn: async ({ chatId, interruptedChatId }) => {
      const wiseOwlApi = new WiseOwlApi(ingress);
      const csrf = await wiseOwlApi.getCsrf();

      switch (ingress) {
        //! Currently we cannot fetch chats for unauthenticated users
        case WiseOwlIngress.oscUngated: {
          throw new Error("Cannot fetch chats for unauthenticated users");
        }
        case WiseOwlIngress.osc: {
          return wiseOwlApi.getChatById({
            interruptedChatId,
            ingress,
            chatId,
            headers: {
              "x-twilio-csrf": csrf,
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<WiseOwlApiResponse<WiseOwlChatType>>;
        }
        case WiseOwlIngress.console: {
          return wiseOwlApi.getChatById({
            ingress,
            applicationId,
            chatId,
            headers: {
              "x-twilio-csrf": csrf,
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<WiseOwlApiResponse<WiseOwlChatType>>;
        }
        case WiseOwlIngress.zendesk: {
          return wiseOwlApi.getChatByAboutTicketId({
            ingress: WiseOwlIngress.zendesk,
            aboutTicketId: ticket.id,
            headers: {
              // TODO: Update with WOZD refactor
              "zendesk-user-id": "12345",
              "wozd-auth": token,
            },
          }) as Promise<
            WiseOwlApiResponse<WiseOwlGetChatAboutTicketIdResponseData>
          >;
        }
        case WiseOwlIngress.salesforce: {
          return wiseOwlApi.getChatById({
            ingress,
            chatId,
            headers: {
              "TODO-SF-HEADER": "TODO-SF-HEADER",
              "TODO-SF-SECOND-HEADER": "TODO-SF-SECOND-HEADER",
            },
            requestOptions: {
              credentials: "include",
            },
          }) as Promise<WiseOwlApiResponse<WiseOwlChatType>>;
        }
      }
    },
  });
};

export default useGetChat;
